<app-login-form class="h-full flex fixed w-full z-10 overflow-auto"></app-login-form>
<lottie-player @fadeIn class="fixed top-0 left-0 w-full h-auto z-0" src="assets/lottie/login-animate.json" background="transparent" loop autoplay>
</lottie-player>